module.exports = __webpack_public_path__ + "img/1762141205102-X1m0jV0L.2ffa7dcb.png";